import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

export interface EnrollmentToStudentRatioResponse {
  ratio: number;
  totalActiveStudents: number;
  totalEnrollments: number;
}

export interface EnrollmentToStudentRatioParams {
  sessionId: string;
}

export const getEnrollmentToStudentRatioAPI = async (
  params: EnrollmentToStudentRatioParams,
) => {
  const response = await baseAPI.get<EnrollmentToStudentRatioResponse>(
    '/dashboard/metrics/enrollment-to-student-ratio',
    {
      params,
    },
  );
  return response.data;
};

export const useGetEnrollmentToStudentRatio = (
  params: EnrollmentToStudentRatioParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [KEYS.ENROLLMENT_TO_STUDENT_RATIO, params.sessionId],
    queryFn: () => getEnrollmentToStudentRatioAPI(params),
    enabled: !!params.sessionId,
  });
};
